import React from 'react';
import { Link } from 'react-router-dom';
import { getImagePath } from '../../utils/imagePath';

/**
 * Banner - Pure component for banner images
 * Follows React Rules: Pure, idempotent, immutable props
 * 
 * @param {string} image - Image path
 * @param {string} link - Link URL
 * @param {string} alt - Alt text
 * @param {string} className - Additional CSS classes
 */
const Banner = ({ 
  image, 
  link = '/store/shop', 
  alt = 'Banner', 
  className = '' 
}) => {
  if (!image) {
    return null;
  }

  return (
    <div className={`li-banner ${className}`}>
      <Link to={link}>
        <img src={getImagePath(image)} alt={alt} />
      </Link>
    </div>
  );
};

export default Banner;

